export default __webpack_public_path__ + "static/media/loading_modal.75b1aa0d.svg";